import React from 'react';
import type { StoredRoom, RoomState } from '../types';

interface RoomListProps {
  rooms: StoredRoom[];
  currentRoomKey: string | null;
  roomState: RoomState;
  onSelectRoom: (key: string) => void;
  onDeleteRoom: (key: string) => void;
  onCreateRoom: (name?: string) => void;
}

export const RoomList: React.FC<RoomListProps> = ({
  rooms,
  currentRoomKey,
  roomState,
  onSelectRoom,
  onDeleteRoom,
  onCreateRoom,
}) => {
  const [newRoomName, setNewRoomName] = React.useState('');

  // Check if a room is being shared (cannot be deleted)
  const isRoomShared = (roomKey: string): boolean => {
    const sharedStates: RoomState['type'][] = [
      'sharing', 'sharingStarting', 'sharingStopping',
      'shared', 'sharedStarting', 'sharedStopped'
    ];
    return roomKey === currentRoomKey && sharedStates.includes(roomState.type);
  };

  const handleCreateRoom = (e: React.FormEvent) => {
    e.preventDefault();
    if (newRoomName.trim()) {
      onCreateRoom(newRoomName.trim());
      setNewRoomName('');
    }
  };

  return (
    <div className="room-list" style={{ marginBottom: '24px' }}>
      <div style={{ display: 'flex', gap: '12px', marginBottom: '16px' }}>
        <form onSubmit={handleCreateRoom} style={{ display: 'flex', gap: '8px', flex: 1 }}>
          <input
            type="text"
            value={newRoomName}
            onChange={(e) => setNewRoomName(e.target.value)}
            placeholder="Kamernaam..."
            style={{ flex: 1, padding: '8px', borderRadius: '4px', border: '1px solid #ccc' }}
          />
          <button
            type="submit"
            disabled={!newRoomName.trim()}
            style={{ padding: '8px 16px', background: !newRoomName.trim() ? '#6c757d' : '#007bff', color: 'white', border: 'none', borderRadius: '4px', cursor: !newRoomName.trim() ? 'not-allowed' : 'pointer' }}
          >
            Nieuwe Kamer
          </button>
        </form>
      </div>

      {rooms.length === 0 ? (
        <p style={{ color: '#666', fontStyle: 'italic' }}>Nog geen kamers. Maak er een aan om JSON te delen.</p>
      ) : (
        <div style={{ display: 'grid', gap: '8px' }}>
          {rooms.map((room) => (
            <div
              key={room.key}
              style={{
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
                padding: '12px',
                background: room.key === currentRoomKey ? '#e3f2fd' : '#f8f9fa',
                border: `1px solid ${room.key === currentRoomKey ? '#2196f3' : '#ddd'}`,
                borderRadius: '4px',
                cursor: 'pointer',
              }}
              onClick={() => onSelectRoom(room.key)}
            >
              <div>
                <strong>{room.name}</strong>
                <div style={{ fontSize: '0.85em', color: '#666' }}>
                  Bijgewerkt: {new Date(room.updatedAt).toLocaleString()}
                </div>
              </div>
              <button
                onClick={(e) => {
                  e.stopPropagation();
                  onDeleteRoom(room.key);
                }}
                disabled={isRoomShared(room.key)}
                style={{ background: isRoomShared(room.key) ? '#6c757d' : '#dc3545', color: 'white', border: 'none', borderRadius: '4px', padding: '4px 8px', cursor: isRoomShared(room.key) ? 'not-allowed' : 'pointer' }}
              >
                Verwijder
              </button>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};
